import React from "react";

import { DynamicForm } from "src/components/Form";

const fields = options => ({ t }) => [
  [
    {
      key: "firstName",
      label: t("forms.firstName"),
      required: true,
    },
    {
      key: "lastName",
      label: t("forms.lastName"),
      required: true,
    },
  ],
  {
    key: "phoneNumber",
    label: t("forms.phoneNumber"),
    required: true,
  },
  {
    key: "email",
    label: t("forms.emailAddress"),
    inputProps: {
      type: "email",
    },
    required: true,
  },
  {
    key: "accountNumber",
    label: t("forms.accountNumber"),
    inputProps: {
      type: "password",
    },
    required: true,
  },
  {
    key: "worksPerkMember",
    label: t("forms.worksPerkMember"),
    type: "optionButtons",
    required: true,
    inputProps: {
      wrap: true,
      options: [
        {
          value: "yes",
          label: t("forms.feedback.yes"),
        },
        {
          value: "no",
          label: t("forms.feedback.no"),
        },
      ],
    },
  },
];

const DirectDepositForm = ({ moduleKey, options }) => (
  <DynamicForm
    formKey={options.formKey || moduleKey}
    fields={fields(options.options)}
    defaultSuccessMessageKey="forms.defaultSuccessMessage"
  />
);

export default DirectDepositForm;



// WEBPACK FOOTER //
// ./src/components/Content/forms/DirectDepositForm.js